export default __webpack_public_path__ + "static/media/time.fde038a1.svg";